import React from 'react';
import { Button, Spinner } from 'react-bootstrap';

interface FormFooterProps {
    next?: () => void;
    previous?: () => void;
    showPrevious: boolean;
    previousLabel?: string;
    showNext: boolean;
    nextLabel?: string;
    nextButtonDisabled: boolean;
    loading: boolean;

}

export default function FormFooter(
    { next, previous, showPrevious, previousLabel, showNext, nextLabel, nextButtonDisabled, loading }: FormFooterProps
) {

    return (
        <div className='form-footer'>
            {showPrevious ? <Button variant='outline-secondary' size='lg' onClick={previous} disabled={loading}>
                { previousLabel || 'Tagasi' }
            </Button> : null}
            {showNext ? <Button variant='secondary' size='lg' onClick={next} disabled={nextButtonDisabled || loading}>
                { nextLabel || 'Edasi'}
                { loading ? <Spinner size={"sm"} animation={"border"} className="ml-1"/> : null }
            </Button> : null}
        </div>
    );
}